// @ts-ignore
import * as colors from 'app_styles/themes/colors.scss'
import { IColorsTheme } from 'app_types/colors'

/**
 * @INFO Obtener un color desde CSS
 * @param color
 * @returns
 */
 export const getColorFromCSS = (color: string): string => {
  const style = getComputedStyle(document.body)
  const response = style.getPropertyValue(color)
  return response
}

/**
 * Metodo que permite obtener los colores segun el tema
 * @param theme Tema que contiene los colores
 * @returns
 */
export const getThemeColorss = (theme: string): IColorsTheme => {
  const keys = Object.keys(colors)
  const themeColors = keys.reduce((acum: Object, item: string) => {
    const themeKey = item.split('_')[0]
    const colorName: string = item.split('_')[1]
    if(themeKey === theme){
      // @ts-ignore
      acum[colorName] = colors[item]
      return acum
    }
    return acum
  }, {})
  return themeColors as IColorsTheme
}

/**
 * Metodo que permite obtener los colores desde CSS
 * @returns
 */
export const getThemeColorsFromCSS = (): IColorsTheme => {
  const style = getComputedStyle(document.body)
  const colors: IColorsTheme = {
    others: {
      white: style.getPropertyValue('--white'),
      gray100: style.getPropertyValue('--gray-100'),
      gray200: style.getPropertyValue('--gray-200'),
      gray300: style.getPropertyValue('--gray-300'),
      gray400: style.getPropertyValue('--gray-400'),
      gray500: style.getPropertyValue('--gray-500'),
      gray600: style.getPropertyValue('--gray-600'),
      gray700: style.getPropertyValue('--gray-700'),
      gray800: style.getPropertyValue('--gray-800'),
      gray900: style.getPropertyValue('--gray-900'),
      black: style.getPropertyValue('--black'),
      // -----------------------------
      blue: style.getPropertyValue('--blue'),
      indigo: style.getPropertyValue('--indigo'),
      purple: style.getPropertyValue('--purple'),
      pink: style.getPropertyValue('--pink'),
      red: style.getPropertyValue('--red'),
      orange: style.getPropertyValue('--orange'),
      yellow: style.getPropertyValue('--yellow'),
      green: style.getPropertyValue('--green'),
      teal: style.getPropertyValue('--teal'),
      cyan: style.getPropertyValue('--cyan'),
      // -----------------------------
      success: style.getPropertyValue('--success'),
      info: style.getPropertyValue('--info'),
      warning: style.getPropertyValue('--warning'),
      danger: style.getPropertyValue('--danger'),
      light: style.getPropertyValue('--light'),
      dark: style.getPropertyValue('--dark'),
    },
    primary: style.getPropertyValue('--primary'),
    secondary: style.getPropertyValue('--secondary'),
    tertiary: style.getPropertyValue('--tertiary'),
    background: style.getPropertyValue('--background'),
    background2: style.getPropertyValue('--background2'),
    black: style.getPropertyValue('--black'),
    grayDark: style.getPropertyValue('--gray-dark'),
    grayLight: style.getPropertyValue('--gray-light'),
    grayMedium: style.getPropertyValue('--gray-medium'),
    text: style.getPropertyValue('--text'),
    text2: style.getPropertyValue('--text2'),
    placeholderBackground: style.getPropertyValue('--placeholder-background'),
    placeholderForeground: style.getPropertyValue('--placeholder-foreground'),
  }
  return colors
}
